<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <img src="klemantina-logo.svg" alt="Klemantina Logo" class="logo">
      <h1>Klemantina</h1>
      <p class="subtitle">Admin Portal</p>
    </div>

    <div class="error-message" *ngIf="error">{{ error }}</div>

    <p *ngIf="completingSso" class="signing-in">Signing you in…</p>

    <button *ngIf="!completingSso" type="button" class="btn-sso" (click)="signInWithMicrosoft()">
      Sign in with Microsoft
    </button>

    <div class="client-link">
      <a routerLink="/login">Client Login →</a>
    </div>
  </div>
</div>
